import { IconButton } from '@mui/material';
import { ReactNode } from 'react';
import { ControlledTextInput } from 'wisestep-base';

interface WorkspaceProps {
  id?: string;
  name: string;
  iconText: ReactNode;
  type: string;
  placeholder?: string;
  labelText?: string;
  defaultValue?: string;
  disable?: boolean;
  required?: boolean;
}

const RecruiterDetailsFields = ({
  id,
  name,
  iconText,
  type,
  placeholder,
  labelText,
  defaultValue,
  disable = false,
  required = false,
}: WorkspaceProps) => {
  return (
    <>
      <IconButton>{iconText}</IconButton>
      <ControlledTextInput
        id={id}
        name={name}
        labelText={labelText}
        type={type}
        fullWidth
        defaultValue={defaultValue}
        placeholder={placeholder}
        disabled={disable}
        required={required}
      />
    </>
  );
};
export default RecruiterDetailsFields;
